<script setup lang="ts"></script>

<template>
  <icon name="lucide:circle-alert" />
</template>

<style scoped></style>
